var rules = {
  manager: {
    "static": ["campus:add_campus", "campus:delete_campus", "campus:edit_staff", "campus:add_group", "campus:add_user", "campus:import_users", "campus:add_staff_trainer", "campus:add_staff_coordinator", "campus:group:add_activity", "campus:group:delete_group", "staff:download_shift_report", "staff:edit_staff"]
  },
  coordinator: {
    "static": ["campus:add_group", "campus:add_user", "campus:import_users", "campus:add_staff_trainer", "campus:group:add_activity", "campus:group:delete_group"],
    dynamic: {
      "campus:edit_staff": function campusEdit_staff(_ref) {
        var role = _ref.role,
            userRole = _ref.userRole;
        if (!role || !userRole) return false;
        return role !== userRole;
      }
    }
  }
};
export default rules;